export default __webpack_public_path__ + "static/media/Datenschutzerklarung.e13f59de.md";